import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHead } from "./parts";

export default function Settings() {
  const { user, logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/change-password", f); toast.success("Password changed"); setF({ current_password: "", new_password: "" }); }
    catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  const resend = async () => {
    try { await api.post("/auth/resend-verification"); toast.success("Verification email sent"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-2xl">
      <PageHead eyebrow="settings" title="account" />
      <div className="panel mb-6 divide-y divide-[#1a1a22]">
        {[["username", `@${user.username}`], ["email", user.email], ["joined", new Date(user.created_at).toLocaleDateString()]].map(([k, v]) => (
          <div key={k} className="flex items-center justify-between px-6 py-4"><span className="eyebrow">{k}</span><span className="text-sm text-white" data-testid={`settings-${k}`}>{v}</span></div>
        ))}
        <div className="flex items-center justify-between px-6 py-4">
          <span className="eyebrow">email status</span>
          {user.email_verified ? <span className="text-sm text-emerald-400" data-testid="settings-email-verified">verified</span>
            : <button onClick={resend} className="text-sm font-semibold text-[#ff3b91] hover:underline" data-testid="settings-resend-verification-button">unverified — resend link</button>}
        </div>
      </div>
      <form onSubmit={change} className="panel space-y-4 p-6" data-testid="change-password-form">
        <div className="font-display text-lg font-semibold">change password</div>
        <input type="password" className="field" placeholder="current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required data-testid="current-password-input" />
        <input type="password" className="field" placeholder="new password (8+)" minLength={8} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required data-testid="new-password-input" />
        <button disabled={busy} className="btn-pink" data-testid="change-password-submit-button">update password</button>
      </form>
      <button onClick={logout} className="btn-ghost mt-6" data-testid="settings-logout-button">log out</button>
    </div>
  );
}
